import i18n from 'services/base/i18n';

export default {
  anyProtocol: () => i18n.pgettext('Components|List History|Filter History|Protocol Input|Range Input', 'Any'),
  fromPrompt:  () => i18n.pgettext('Components|List History|Filter History|Protocol Input|Range Input', 'from'),
  untilPrompt: () => i18n.pgettext('Components|List History|Filter History|Protocol Input|Range Input', 'until'),
};
